import Wrapper from "./Wrapper";
import New from "./New";
import Edit from "./Edit";

export default {
  Wrapper,
  New,
  Edit
};
